import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosClient } from '../../../core/axios-client';

export const fetchInvitations = createAsyncThunk(
  'fetchInvitations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get('/operator-invitations/');
      return response.data.results || response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCourierInvitations = createAsyncThunk(
    'fetchCourierInvitations',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosClient.get('/courier-invitations/');
            return response.data.results || response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const createInvitation = createAsyncThunk(
  'createInvitation',
  // Отправляем всё, что собрала форма: раньше здесь разбирались только email
  // и company_id, и имя с телефоном, а теперь и настройки триала, молча
  // терялись по дороге
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/operator-invitations/', payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchInvitationGrantOptions = createAsyncThunk(
  'fetchInvitationGrantOptions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get('/operator-invitations/grant-options');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const slice = createSlice({
    name: 'invitations',
    initialState: {
      items: [],
      loading: false,
      error: null,
      courierItems: [],
      courierLoading: false,
      courierError: null,
      grantOptions: { plans: [], partner_programs: [], default_ttl_days: 7 },
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchInvitations.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchInvitations.fulfilled, (state, { payload }) => {
          state.loading = false;
          state.items = payload;
        })
        .addCase(fetchInvitations.rejected, (state, { payload }) => {
          state.loading = false;
          state.error = payload;
        })
        .addCase(createInvitation.pending, (state) => {
          state.error = null;
        })
        .addCase(createInvitation.fulfilled, (state, { payload }) => {
          state.items.unshift(payload);
        })
        .addCase(createInvitation.rejected, (state, { payload }) => {
          state.error = payload;
        })
        .addCase(fetchInvitationGrantOptions.fulfilled, (state, { payload }) => {
          state.grantOptions = payload;
        })
        .addCase(fetchCourierInvitations.pending, (state) => {
            state.courierError = null;
        })
        .addCase(fetchCourierInvitations.fulfilled, (state, { payload }) => {
            state.courierLoading = false;
            state.courierItems = payload;
        })
        .addCase(fetchCourierInvitations.rejected, (state, { payload }) => {
            state.courierLoading = false;
            state.courierError = payload;
        });
    }
});

export default slice.reducer;